<template>
  <el-dialog :title="title" :visible="dialogVisible" width="30%" @close="close">
    <!-- 创建角色 -->
    <div class="add-popup-body">
      <el-form
        :model="userForm"
        :rules="userRules"
        ref="formData"
        @submit.native.prevent
        label-position="top"
        class="itemAlter"
      >
        <el-form-item
          v-for="item in userProps"
          :key="item.prop"
          :label="item.label"
          :prop="item.prop"
          @keyup.enter.native="submitForm('formData')"
        >
          <div>
            <el-input
              v-model="userForm[item.prop]"
              :placeholder="item.placeholder"
            ></el-input>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button @click="close()">取消</el-button>
      <el-button type="primary" @click="submitForm('formData')">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
    },
  },
  data() {
    return {
      userForm: {
        name: "",
        userPowerRole: "",
      },
      userProps: [
        {
          prop: "name",
          label: this.$t("user.roleName"),
          placeholder: this.$t("alertMsg.userRole"),
        },
        {
          prop: "userPowerRole",
          label: "权限",
          placeholder: "请输入内容",
        },
      ],
      userRules: {
        name: [
          {
            required: true,
            message: "内容不能为空",
            trigger: "blur",
          },
        ],
        userPowerRole: [
          {
            required: true,
            message: "内容不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("confirm", this.userForm);
        } else {
          return false;
        }
      });
    },
    close() {
      this.$emit("close");
      this.$refs.formData.resetFields();
    },
  },
  mounted() {},
  created() {},
};
</script>

<style lang="scss">
</style>
